import { Stack, Typography } from "@mui/material";
import React from "react";
import { FontFamily } from "../getAlphabetForIndex";

interface ChipProps {
  label: string;
  color: string;
}

const Chip: React.FC<ChipProps> = ({ label, color }) => {
  return (
    <Stack
      bgcolor={"#FFFFFF"}
      py={"4px"}
      px={"8px"}
      borderRadius={"32px"}
      border={`1px solid ${color}`}
    >
      <Typography
        fontFamily={FontFamily.gilroy}
        color={color}
        fontWeight={600}
        fontSize={"10px"}
        lineHeight={"125%"}
        letterSpacing={"-0.2px"}
      >
        {label}
      </Typography>
    </Stack>
  );
};

export default Chip;
